<!-- 个人中心 -->
<template>
  <div class="profile">
    <!-- 背景墙 -->
    <div class="profile-box">
      <div class="profile-user" @click="userInfo==''?navGo(0):''">
        <div class="user-info">
          <span class="user-name">Hi~，{{userInfo.name?userInfo.name:'游客'}}</span>
          <div class="info-item" v-show="userInfo!=''">
            <span>{{age===''?'暂未填写':`${age}岁`}}</span>
            <span>{{userInfo.education_name===''?'暂未填写':`${userInfo.education_name}`}}</span>
            <span>{{userInfo.soldier_type_name===''?'暂未填写':`${userInfo.soldier_type_name}`}}</span>
          </div>
        </div>
        <img
          :src="userInfo.avatar?userInfo.avatar:require('@/assets/img/home/timg.jpg')"
          class="user-img"
        />
      </div>
      <div class="profile-situation">
        <div class="situation-item" @click="navGo(1)">
          <span class="situation-num">{{apply}}</span>
          <span class="situation-name">申请记录</span>
        </div>
        <div class="situation-item" @click="navGo(2)">
          <span class="situation-num">{{Interview}}</span>
          <span class="situation-name">面试</span>
        </div>
        <div class="situation-item" @click="navGo(5)">
          <span class="situation-num">{{gettotal}}</span>
          <span class="situation-name">受邀面试</span>
        </div>
        <div class="situation-item" @click="navGo(3)">
          <span class="situation-num">{{collected}}</span>
          <span class="situation-name">收藏</span>
        </div>

        <div class="situation-item" @click="navGo(4)">
          <span class="situation-num">{{browse}}</span>
          <span class="situation-name">浏览记录</span>
        </div>
      </div>
    </div>
    <!-- 列表项 -->
    <div class="profile-list">
      <div class="list-box">
        <div class="list-item" @click="getNext(0)">
          <span class="list-title">求职意向</span>
          <div class="list-right">
            <span>{{status}}</span>
            <img src="@/assets/img/position/into.png" class="list-img" />
          </div>
        </div>

        <div class="list-item" @click="getNext(1)">
          <span class="list-title">我的简历</span>
          <div class="list-right">
            <!-- <span>随时到岗</span> -->
            <img src="@/assets/img/position/into.png" class="list-img" />
          </div>
        </div>
        <div class="list-item" @click="getNext(2)">
          <span class="list-title">活动记录</span>
          <div class="list-right">
            <img src="@/assets/img/position/into.png" class="list-img" />
          </div>
        </div>
        <!-- <div class="list-item" @click="getNext(3)">
          <span class="list-title">我的咨询</span>
          <div class="list-right">
            <img src="@/assets/img/position/into.png" class="list-img" />
          </div>
        </div>-->
        <div class="list-item" @click="wechat(wechatNum)" v-show="shows">
          <span class="list-title">{{is_bind_wechat}}</span>
        </div>
      </div>
    </div>

    <!-- 我要招人-->
    <div class="profile-list" @click="getNext(4)">
      <div class="list-box">
        <div class="list-item">
          <span class="list-title">我要招人</span>
          <div class="list-right">
            <!-- <span>随时到岗</span> -->
            <img src="@/assets/img/position/into.png" class="list-img" />
          </div>
        </div>
      </div>
    </div>

    <!-- 退出登录 -->
    <div class="exit-login" v-show="show">
      <button class="exit-btn" @click="loginOut">退出登录</button>
    </div>
  </div>
</template>

<script>
import {
  getWatchNum,
  getCollectNum,
  getApplyNum,
  getInterviewNum,
  queryPreson,
  MemberLoginOut,
  lawyerList,
  queryPersonalInfo,
  wechatUnbind,
  wechatBind,
  JobInvite,
  getTotal
} from "@/api/apiData";
import { Toast, Dialog } from "vant";
import { mapState, mapMutations } from "vuex";
import GetQueryString from "@/until/getParams";
export default {
  inject: ["Token"],
  data() {
    return {
      status: "请选择求职意向", //求职状态
      browse: 0, //浏览记录
      collected: 0, //收藏
      apply: 0, //申请
      Interview: 0, //面试
      userInfo: "", //个人信息
      age: "",
      show: false,
      shows: false,
      is_bind_wechat: "",
      wechatNum: "",
      gettotal: 0
    };
  },
  computed: {
    ...mapState(["loginType", "token", "logins"])
  },
  methods: {
    ...mapMutations(["getToken", "refreshCode"]),
    //   路由跳转
    navGo(val, type) {
      var that = this;
      if (val == 0) {
        that.$router.push({
          name: "Login"
        });
      } else if (val == 3) {
        // 收藏
        that.$router.push({
          path: "/profile/collect",
          query: {
            type: "0"
          }
        });
      } else if (val == 1) {
        // 申请记录
        that.$router.push({
          path: "/profile/collect",
          query: {
            type: "2"
          }
        });
      } else if (val == 4) {
        // 浏览记录
        that.$router.push({
          path: "/profile/collect",
          query: {
            type: "1"
          }
        });
      } else if (val == 2) {
        // 面试
        that.$router.push({
          name: "Interview"
        });
      } else {
        that.$router.push({
          name: "companyInvite"
        });
      }
    },
    // 列表路由跳转
    getNext(val) {
      if (val == 0) {
        // 求职意向
        this.$router.push({
          name: "JobSearch"
        });
      } else if (val == 1) {
        // 我的简历
        this.$router.push({
          name: "Resume"
        });
      } else if (val == 4) {
        //我要招人

        Dialog.confirm({
          title: "企业登录",
          message: "是否前往登录企业账号"
        })
          .then(() => {
            window.location.href =
              "https://ncxtyjrwork.nccloudmedia.com/web/#/login/account";
            // window.location.href = "http://192.168.9.173:8085/#/login/account";
            // this.$router.replace({
            //   name: "Login"
            // });
          })
          .catch(() => {});
        // this.$router.push({
        //   name: "HomeBoss",
        //   params: {
        //     type: 0
        //   }
        // });
      } else if (val == 2) {
        this.$router.push({
          name: "Activity",
          params: {
            type: 0
          }
        });
      } else {
        lawyerList().then(res => {
          // //(res);
          if (res.code == 1) {
            this.$router.replace({
              name: "Train"
              // query: {
              //   title: `${res.data[0].nickname}律师`
              // }
            });
          }
        });
      }
    },
    // 获取 浏览 收藏 申请记录 总数  个人信息
    getNum() {
      var that = this;
      // 个人信息
      queryPreson().then(res => {
        if (res.code == 1) {
          var userInfo = res.data;
          that.userInfo = userInfo;
          var time = new Date();
          var Y = time.getFullYear();
          var arr = userInfo.birthday.split("-");
          that.age = Y - Number(arr[0]) + 1;
          var item = userInfo.apply_status;
          that.status = item.name;
        }
      });
      // 浏览
      getWatchNum().then(res => {
        if (res.code == 1) {
          that.browse = res.data.total;
          that.show = true;
        } else {
          // Toast(res.msg);
          that.show = false;
        }
      });
      // 收藏
      getCollectNum().then(res => {
        if (res.code == 1) {
          that.collected = res.data.total;
        } else {
          // Toast(res.msg);
        }
      });
      // 申请总数
      getApplyNum().then(res => {
        if (res.code == 1) {
          that.apply = res.data.total;
        } else {
          // Toast(res.msg);
        }
      });
      // 等待面试
      getInterviewNum().then(res => {
        // //(res);
        if (res.code == 1) {
          that.Interview = res.data.total;
        } else {
          // Toast(res.msg);
        }
      });
      getTotal().then(res => {
        //(res);
        if (res.code == 1) {
          that.gettotal = res.data.total;
        }
      });
    },
    loginOut() {
      const that = this;
      Dialog.confirm({
        title: "登录退出",
        message: "是否退出登录"
      })
        .then(res => {
          MemberLoginOut({ token: that.token }).then(res => {
            if (res.code == 1) {
              Toast.success({
                message: "退出成功",
                forbidClick: true
              });
              that.getToken(["", ""]);
              that.queryInfo();
              that.userInfo = "";
              that.browse = 0; //浏览记录
              that.collected = 0; //收藏
              that.apply = 0; //申请
              that.Interview = 0; //面试
              that.gettotal = 0; //受邀面试
              that.show = false;
              that.status = "请选择求职意向";
            }
          });
        })
        .catch(() => {});
    },
    // 微信绑定
    wechat(wechatNum) {
      const that = this;
      if (wechatNum == 0) {
        //绑定
        that.refreshCode(2);
        var params = {
          appid: "wx0d3c07901732c258",
          redirect_uri:
            "https%3a%2f%2fncxtyjrwork.nccloudmedia.com%2fweb%2f%23%2fprofile",
          response_type: "code",
          scope: "snsapi_userinfo",
          state: 123456
        };
        window.location.href = `https://ncymkj.doudou00.com/get-weixin-code.html?appid=${params.appid}&redirect_uri=${params.redirect_uri}&response_type=${params.response_type}&scope=${params.scope}&state=${params.state}`;
      } else {
        //解绑
        Dialog.confirm({
          title: "提示",
          message: "确定将该账号与微信解绑吗？"
        })
          .then(() => {
            wechatUnbind({ token: that.token }).then(res => {
              //(res);
              if (res.code == 1) {
                Toast.success({
                  forbidClick: true,
                  message: res.msg
                });
                that.queryInfo();
              } else {
                Toast.success({
                  forbidClick: true,
                  message: res.msg
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    // 查询
    queryInfo() {
      queryPersonalInfo({ token: this.token }).then(res => {
        //(res);
        if (res.code == 1) {
          this.shows = true;
          if (res.data.is_bind_wechat == 0) {
            this.is_bind_wechat = "微信绑定";
            if (GetQueryString("code")) {
              if (this.logins == 2) {
                wechatBind({
                  token: this.token,
                  code: GetQueryString("code")
                }).then(res => {
                  //(res);
                  if (res.code == 1) {
                    Toast.success({
                      forbidClick: true,
                      message: res.msg
                    });
                    this.refreshCode(1);
                    this.queryInfo();
                  } else {
                    this.refreshCode(1);
                    Toast.fail({
                      forbidClick: true,
                      message: res.msg
                    });
                  }
                });
              }
            }
          } else {
            this.is_bind_wechat = "解绑微信";
          }
          this.wechatNum = res.data.is_bind_wechat;
        } else {
          this.shows = false;
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getNum();
    this.Token();
    this.queryInfo();
  }
};
</script>
<style lang='less' scoped>
.profile {
  background: #f0f2f5;
  padding-bottom: 0.95rem;

  // 背景墙
  .profile-box {
    width: 100%;
    background: linear-gradient(#ff4a4d, #f82d2f);
    border-radius: 0 0 5% 5%;
    padding: 0.3rem 0.4rem;
    // position: relative;
    .profile-user {
      display: flex;
      justify-content: space-between;
      .user-info {
        display: flex;
        flex-direction: column;
        .user-name {
          font-size: 0.48rem;
          font-weight: bold;
          line-height: 0.67rem;
          color: rgba(255, 255, 255, 1);
          text-align: left;
        }
        .info-item {
          display: flex;
          align-items: center;
          margin-top: 0.1rem;
          span {
            display: flex;
            align-items: center;
            font-size: 0.26rem;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.8);
          }
          span::after {
            content: "";
            width: 0.03rem;
            height: 0.26rem;
            display: block;
            background: rgba(255, 255, 255, 0.8);
            margin: 0 0.2rem;
          }
          span:last-child::after {
            display: none;
          }
        }
      }
      .user-img {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 50%;
      }
    }
    .profile-situation {
      display: flex;
      align-items: center;
      margin-top: 0.4rem;
      padding-bottom: 1.2rem;
      .situation-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .situation-num {
          font-size: 0.36rem;
          font-weight: bold;
          line-height: 0.5rem;
          color: rgba(255, 255, 255, 1);
        }
        .situation-name {
          font-size: 0.22rem;
          font-weight: 400;
          line-height: 0.3rem;
          color: rgba(255, 255, 255, 0.8);
          margin: 0.1rem;
        }
      }
    }
  }
  //   列表项
  .profile-list {
    position: relative;
    z-index: 10;
    top: -1rem;
    padding: 0 0.32rem;
    .list-box {
      background: #fff;
      border-radius: 0.16rem;
      .list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.3rem 0.32rem;
        .list-title {
          font-size: 0.28rem;
          font-weight: bold;
          line-height: 0.4rem;
          color: rgba(51, 51, 51, 1);
        }
        .list-right {
          display: flex;
          align-items: center;
          font-size: 0.26rem;
          font-weight: 400;
          line-height: 0.37rem;
          color: rgba(153, 153, 153, 1);
          .list-img {
            width: 0.4rem;
            height: 0.4rem;
          }
        }
      }
    }
  }
  .profile-list:nth-child(3) {
    margin-top: 0.3rem;
  }
  //   退出登录
  .exit-login {
    // margin: 2rem 0 0.1rem;
    padding: 0 0.32rem;
    width: 100%;
    display: flex;
    align-items: center;

    .exit-btn {
      width: 100%;
      background: #ffffff;
      border-radius: 0.16rem;
      height: 1rem;
      font-size: 0.32rem;
      font-weight: 400;
      line-height: 1rem;
      color: rgba(153, 153, 153, 1);
    }
  }
}
</style>